import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Info icon shown after a dashboard section heading.
 * @param {{ lines: string[] }} props
 */
export default function SectionInfoIcon({ lines }) {
  return (
    <Tooltip
      arrow
      placement="right"
      slotProps={{
        tooltip: {
          sx: { maxWidth: 360 },
        },
      }}
      title={
        <Box sx={{ py: 0.25 }}>
          {lines.map((line) => (
            <Typography
              key={line}
              component="div"
              sx={{ fontSize: "12px", lineHeight: 1.5 }}
            >
              {line}
            </Typography>
          ))}
        </Box>
      }
    >
      <IconButton
        size="small"
        aria-label="How this section is calculated"
        sx={{ p: 0.25, ml: 0.5 }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
      </IconButton>
    </Tooltip>
  );
}
